import { UserRole } from 'shared/types';

import { RoutePath, HomeRoutePath } from './routePaths';

export const ROLE_PERMISSIONS_BY_ROUTE: Readonly<Record<string, UserRole[]>> = {
  [HomeRoutePath.StudentObserver]: [UserRole.Admin, UserRole.Staff],
  [HomeRoutePath.AdminSchoolLinks]: [UserRole.Admin, UserRole.Staff],
  [HomeRoutePath.SchoolLinksManager]: [UserRole.Admin, UserRole.Staff],
  [HomeRoutePath.Dashboard]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [HomeRoutePath.Calendar]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [HomeRoutePath.Subjects]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [HomeRoutePath.Progress]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [HomeRoutePath.ParentHelper]: [UserRole.Parent],
  [HomeRoutePath.SchoolLinks]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [HomeRoutePath.PrivacyNotice]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [HomeRoutePath.CookiesPolicy]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],
  [HomeRoutePath.TermsOfUse]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
  ],

  // TODO: refactor lists by roots
  [RoutePath.SchoolLinks]: [UserRole.Admin, UserRole.Staff],
  [RoutePath.SchoolLinksManager]: [UserRole.Admin],

  // TODO: these pages will be implemented in the post MVP phase
  [HomeRoutePath.Reports]: [],
  [HomeRoutePath.Library]: [],
};
